export default {"src":"/_next/static/media/Company3.9c382c11.svg","height":60,"width":160,"blurWidth":0,"blurHeight":0};